module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shipping-options"
  }, [(_vm.loading) ? _c('div', [_c('strong', [_vm._v("Select a shipping method")]), _vm._v(" "), _c('br'), _vm._v("\n        Loading...\n        "), _c('loaders', {
    attrs: {
      "loader": "rolling"
    }
  })], 1) : _c('div', [(_vm.shippingMethod !== false) ? _c('div', [_c('strong', [_vm._v("Shipping Method")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "shipping-method"
  }, [(_vm.shippingMethod.provider === 'UPS') ? _c('img', {
    attrs: {
      "src": "/static/ups.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shippingMethod.provider === 'USPS') ? _c('img', {
    attrs: {
      "src": "/static/usps.svg"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.shippingMethod.provider) + " " + _vm._s(_vm.shippingMethod.name) + "\n                    - " + _vm._s(_vm._f("currency")(_vm.shippingMethod.amount)) + "\n                    "), _c('br'), _vm._v("\n                    Delivery in "), _c('strong', [_vm._v(_vm._s(_vm.shippingMethod.estimate + 5) + " - " + _vm._s(_vm.shippingMethod.estimate + 7) + " days")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('em', [_vm._v("Delivery is an estimate based on manufacturing turnaround time.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button btn-sm",
    on: {
      "click": function($event) {
        return _vm.clearOption()
      }
    }
  }, [_vm._v("Change Service")])]) : _c('div', [_c('strong', [_vm._v("Select a shipping method")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.shippingMethods.length < 1) ? _c('div', [_vm._v("\n                Hmmm... The shipping methods couldn't be loaded.\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button btn-sm",
    on: {
      "click": function($event) {
        return _vm.loadMethods()
      }
    }
  }, [_vm._v("Retry")]), _vm._v(" "), _c('br')]) : _c('div', [_vm._l((_vm.sortedShippingMethods), function(method) {
    return _c('div', {
      staticClass: "shipping-option",
      on: {
        "click": function($event) {
          return _vm.setOption(method.token)
        }
      }
    }, [(method.provider === 'UPS') ? _c('img', {
      attrs: {
        "src": "/static/ups.svg"
      }
    }) : _vm._e(), _vm._v(" "), (method.provider === 'USPS') ? _c('img', {
      attrs: {
        "src": "/static/usps.svg"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(method.provider) + " " + _vm._s(method.name))]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(method.estimate) + " business days - " + _vm._s(_vm._f("currency")(method.amount)) + "\n                    ")])])
  }), _vm._v(" "), _vm._m(0)], 2)])]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_vm._v("Depending on our available stock, please allow "), _c('strong', {
    staticStyle: {
      "color": "#D33"
    }
  }, [_vm._v("up to 5 extra business days")]), _vm._v(" for manufacturing lead time!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b93beffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShippingOptions.vue
// module id = 226
// module chunks = 1